const getPercentage = (count: number, total: number, minPercentage: number) => {
    const percentage = (count / total) * 100;
    if (percentage < minPercentage) {
        return minPercentage;
    }
    return percentage;
}
export function StatusCounter({ statusData, certification }: { statusData: any, certification: any }) {
    const counts = certification?.counts || [];
    const total = counts.reduce((acc, count: any) => acc + count.count, 0) as number;
    const minPercentage = 10;
    const filteredCounts = counts.filter((count) => count?.count > 0);
    return (
        <div className="flex items-center">
            {
                filteredCounts.map((countData, index) => {
                    return (
                        <div
                            key={countData?.status}
                            className={`h-3.5 rounded-full border border-white relative`}
                            style={{
                                width: `calc(${getPercentage(countData?.count, total, minPercentage)}% + ${index !== 0 ? 10 : 0}px)`,
                                zIndex: counts.length - index,
                                marginLeft: index !== 0 ? -10 : 0,
                                backgroundColor: statusData?.[countData?.status]?.statusBackgroundColor,
                            }}
                        >
                        </div>
                    )
                })
            }
            {
                filteredCounts.length === 0 && (
                    <div
                        className={`h-3.5 rounded-full border border-white relative`}
                        style={{
                            width: `100%`,
                            backgroundColor: statusData?.["pending"]?.statusBackgroundColor,
                        }}
                    />
                )
            }
        </div>
    )
}